// extracted by mini-css-extract-plugin
export var link = "_v3-0";